import useAxios from 'axios-hooks';

export const useContent = () => {
    const [{ data, loading, error }, refetch] = useAxios('/api/content');

    return [data, loading, error, refetch];
};
